import * as ReactHelmetAsync from 'react-helmet-async';
const Helmet = ReactHelmetAsync.Helmet || (ReactHelmetAsync as any).default?.Helmet;
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/layout/Navigation';
import { Footer } from '@/components/layout/Footer';
import { PageHero } from '@/components/sections/PageHero';

export function TailwheelRefresh() {
  return (
    <>
      <Helmet>
        <title>Tailwheel Refresh | Total Tailwheel</title>
        <meta
          name="description"
          content="Tailwheel refresher training to build proficiency before flying a tailwheel aircraft. Located at Minute Man Air Field in Stow, MA, near Boston."
        />
        <link rel="canonical" href="https://totaltailwheel.com/training/tailwheel-refresh" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <PageHero title="Tailwheel Refresh" />

        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <div className="bg-white p-8 rounded-lg shadow-md">
                <p className="text-foreground/80 mb-4">
                  Have a tailwheel endorsement but haven't flown a taildragger in a while? Maybe you have an
                  opportunity to fly a tailwheel aircraft and want to get proficient again first. A refresher
                  in our Cessna 170B is a great way to build time and sharpen your skills before you go.
                </p>

                <p className="text-foreground/80 mb-6">
                  We'll tailor the training to your goals — whether that's crosswind landings, short field
                  operations, or just getting comfortable with the sight picture and ground handling again.
                  No minimum hour requirement.
                </p>

                <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
                  <p className="text-sm text-foreground/70">
                    Located at <strong>Minute Man Air Field (6B6)</strong> in Stow, MA — just 30 minutes west of Boston,
                    with easy access from Route 2 and Route 495.
                  </p>
                </div>

                <div className="text-center">
                  <Link
                    to="/inquire"
                    className="inline-block bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors font-medium"
                  >
                    Inquire Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}
